import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {categories.map((category, index) => (
        <Link
          key={category.id}
          to={`/category/${category.id}`}
          className={`group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 ${
            index === 0 ? "lg:col-span-2 lg:row-span-2" : ""
          }`}
          style={{ animationDelay: `${index * 80}ms` }}
          title={`${category.name} - 国模白露写真作品集`}
        >
          <div className={`relative w-full ${index === 0 ? "aspect-[16/10] lg:h-full lg:aspect-auto lg:min-h-[420px]" : "aspect-[16/10]"}`}>
            <img
              src={category.cover}
              alt={`${category.name} - 国模白露分类封面`}
              title={`${category.name}写真作品集`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
              <h3 className="flex items-center gap-2 text-lg font-bold text-white md:text-xl">
                {category.name}
                <i className="ri-arrow-right-up-line text-primary-300 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </h3>
              <p className={`mt-2 text-xs leading-relaxed text-white/75 ${index === 0 ? "lg:max-w-md md:text-sm" : "line-clamp-2"}`}>
                {category.description}
              </p>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}